export const correctRepoFormat = (repoName: string) =>
  /^[A-Za-z0-9_.-]+\/[A-Za-z0-9_.-]+$/.test(repoName);

export const getIsFormSendable = ({
  repoName,
  personalToken,
  useSameToken
}: {
  repoName: string;
  personalToken: string;
  useSameToken: boolean;
}) => {
  if (!correctRepoFormat(repoName)) return false;
  if (repoName && personalToken) return true;
  if (repoName && useSameToken) return true;
  return false;
};
